import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import {withRouter, Link, Redirect} from 'react-router-dom'
import { Form, Input, Button, message, Modal, Checkbox, Card, Space } from 'antd'
import { MOBILE_REG, TOKEN_KEY, passwordValidator } from '@/constants'
import Cookies from 'js-cookie'
import { getCaptcha, sendSmsCode, userRegister, registerMobileCheck } from 'request/user'
import LoginCommonFrame from '@/components/container/login-common-frame'
import { actionCreators } from 'store'
import { params } from 'util'
import './style.scss'
import Agrement from './agrement'
import PersonalInfo from './personal-info'
import AgreementModal from '../../components/agreementModal'

function Register(props) {
  const mobile = params('mobile')
  const inviteCode = params('inviteCode')
  const { setLoginStatus, isLogin } = props
  const [isShowCaptchaDialog, setIsShowCaptchaDialog] = useState(false)
  const [captcha, setCaptcha] = useState('')
  const [registerData, setRegisterData] = useState({ phone: mobile || '', inviteCode: inviteCode || '' })
  const [isPhoneChecked, setIsPhoneChecked] = useState(null)
  const [captchaUrl, setCaptchaUrl] = useState(getCaptcha)
  const [captchaBtnText, setCaptchaBtnText] = useState('获取验证码')
  const [captchaLeftSeconds, setCaptchaLeftSeconds] = useState(0)
  const [aggrementVisible, setAggrementVisible] = useState(false)

  const formRef = useRef(null)

  useEffect(() => {
    const { phone } = registerData
    if (phone && MOBILE_REG.test(phone)) {
      checkPhone(phone).catch(e => message.error(e.message))
    } else {
      setIsPhoneChecked(null)
    }
  }, [registerData.phone])

  useEffect(() => {
    if (captchaLeftSeconds > 0) {
      setCaptchaBtnText(`重新获取(${captchaLeftSeconds}秒)`)
      setTimeout(() => setCaptchaLeftSeconds(captchaLeftSeconds - 1), 1000)
    } else {
      setCaptchaBtnText('获取验证码')
    }
  }, [captchaLeftSeconds])
  const confirmPasswordValidator = (rule, value) => {
    if (!value || !value.trim()) {
      return Promise.reject(new Error('请再次输入密码'))
    }
    const values = formRef.current.getFieldsValue()
    if (value !== values.password) {
      return Promise.reject(new Error('两次密码输入不一致'))
    }
    return Promise.resolve()
  }
  const checkPhone = async(username) => {
    const { success, message: errMsg, data } = await registerMobileCheck({ username })
    if (!success) {
      return message.error(errMsg)
    }
    setIsPhoneChecked(data && !data.exist)
  }

  const getSmsCode = () => {
    if (captchaLeftSeconds > 0) return false
    const { phone } = registerData
    if (!phone) {
      return message.warn('请输入手机号')
    }
    if (!MOBILE_REG.test(phone)) {
      return message.warn('请输入正确的手机号')
    }
    isPhoneChecked && setIsShowCaptchaDialog(true)
  }

  const sendCode = async() => {
    if (!captcha) {
      return message.warn('请输入验证码')
    }
    const { success, message: errMsg } = await sendSmsCode({ captcha, type: 'REGISTER', phone: registerData.phone })
    if (!success) {
      resetCaptcha()
      return message.error(errMsg)
    }
    setCaptchaLeftSeconds(60)
    setIsShowCaptchaDialog(false)
  }

  const resetCaptcha = () => {
    setCaptchaUrl(`${getCaptcha}?t=${new Date().getTime()}`)
  }
  const handleAccept = () => {
    setAggrementVisible(false)
    formRef.current.setFieldsValue({agreement: true})
    setRegisterData({ ...registerData, agreement: true })
  }
  const onSubmit = async() => {
    const values = formRef.current.getFieldsValue()
    const { success, message: errMsg, data } = await userRegister(values)
    if (!success) {
      return message.error(errMsg)
    }
    Cookies.set(TOKEN_KEY, data.token, { expires: 1 }) // 设置token有效期1天
    setLoginStatus(true)
  }

  return (
    isLogin ? <Redirect to="/"/> : (
      <>
        <LoginCommonFrame title="欢迎注册">
          <Form
            onFinish={onSubmit}
            initialValues={{
              phone: mobile || '',
              inviteCode: inviteCode || ''
            }}
            ref={formRef}
          >
            <div>
              <Form.Item
                name="phone"
                rules={[
                  { required: true, message: '手机号不能为空' }
                ]}
              >
                <Input
                  defaultValue={registerData.phone}
                  size="large"
                  placeholder="请输入手机号"
                  onChange={e => setRegisterData({ ...registerData, phone: e.target.value.trim() })}
                />
              </Form.Item>
              {isPhoneChecked === false && (
                <div className="warning-mobile">该手机号已注册，请选择登录或更换手机号</div>
              )}
            </div>
            <div style={{ marginBottom: '6px' }}>
              <Form.Item
                name="smsCode"
                rules={[
                  { required: true, message: '验证码不能为空' }
                ]}
              >
                <Input size="large" placeholder="请输入验证码" addonAfter={
                  <span
                    style={{ display: 'inline-block', width: '120px', cursor: 'pointer' }}
                    className="captcha-text"
                    onClick={getSmsCode}
                  >
                    {captchaBtnText}
                  </span>
                }/>
              </Form.Item>
            </div>
            <div>
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: '密码不能为空' },
                  { validator: passwordValidator }
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="请输入密码"
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                name="confirmPassword"
                rules={[
                  { required: true, message: '请再次输入密码' },
                  { validator: confirmPasswordValidator }
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="请再次输入密码"
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                name="companyName"
                rules={[
                  { required: true, message: '公司名称不能为空' }
                ]}
              >
                <Input
                  size="large"
                  placeholder="请输入公司名称"
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                name="brandName"
                rules={[
                  { required: true, message: '品牌名称不能为空' }
                ]}
              >
                <Input
                  size="large"
                  placeholder="请输入品牌名称"
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                name="contacts"
                rules={[
                  { required: true, message: '联系人不能为空' }
                ]}
              >
                <Input
                  size="large"
                  placeholder="请输入联系人姓名"
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item name="inviteCode">
                <Input
                  disabled={!!inviteCode}
                  size="large"
                  placeholder="请输入邀请人（选填）"
                />
              </Form.Item>
            </div>
            <div>
              <Form.Item
                name="agreement"
                valuePropName="checked"
                initialValue={false}

                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject(new Error('请先阅读并同意《SIMBOSS管理平台服务协议》、《个人信息保护政策》'))
                  }
                ]}
              >
                <Checkbox
                  disabled={!registerData.agreement}
                  style={{fontSize: 12}}
                  onChange={e => setRegisterData({ ...registerData, agreement: e.target.value })}
                >同意<a onClick={() => setAggrementVisible(true)}>《SIMBOSS管理平台服务协议》、《个人信息保护政策》</a></Checkbox>
              </Form.Item>
            </div>
          </Form>
          <p>
            <Button size="large" className="login-btn" type="primary" onClick={() => formRef.current.submit()}>
              完成注册并登录
            </Button>
          </p>
          <div>
            已有账号，<Link to="/login">立即登录</Link>
          </div>
        </LoginCommonFrame>

        <AgreementModal
          onOk={handleAccept}
          onCancel={() => setAggrementVisible(false)}
          visible={aggrementVisible}
          width='80%'
          title={'《SIMBOSS管理平台服务协议》、《个人信息保护政策》'}
        >
          <Space direction={'vertical'}>
            <Card title={'SIMBOSS管理平台服务协议'}>
              <Agrement />
            </Card>

            <Card title={'个人信息保护政策'}>
              <PersonalInfo />
            </Card>
          </Space>
        </AgreementModal>

        {isShowCaptchaDialog && (
          <Modal
            title="获取验证码"
            visible={isShowCaptchaDialog}
            onCancel={() => setIsShowCaptchaDialog(false)}
            onOk={sendCode}
            okText="确定"
            cancelText="取消"
          >
            <Input
              placeholder="请输入验证码"
              size="large"
              value={captcha}
              onChange={e => setCaptcha(e.target.value.trim())}
              addonAfter={<span style={{ display: 'inline-block', width: '100px', cursor: 'pointer' }}>
                <img
                  style={{ height: '38px', width: '100%' }}
                  src={captchaUrl}
                  onClick={resetCaptcha}
                  alt="验证码"
                />
              </span>}
            />
          </Modal>
        )}</>
    )
  )
}

export default connect(state => ({
  isLogin: state.getIn(['common', 'isLogin'])
}), dispatch => ({
  setLoginStatus(value) {
    dispatch(actionCreators.setLoginStatus(value))
  }
}))(withRouter(Register))
